<script>
export let team;


import { Navigate } from 'svelte-router-spa';


let team_instance_name = team.team.name;

if (!!team.birth_year) {
	team_instance_name = team_instance_name.replace('(First Year)', '(' + team.birth_year + ')');
	team_instance_name = team_instance_name.replace('(Second Year)', '(' + team.birth_year + ')');
}



</script>


<style>

:global(.team) {
	display: block;
	/*margin-bottom: 1rem;*/
}

.card-content {
	padding: 1.15rem 1.15rem !important;
}

.team-image {

}

.team-name {
	margin-bottom: 0.175rem;
	color: #1f1f1f;
	font-size: 1.125rem;
}

.team-level {
	color: #3c3c3c;
	font-size: 1rem;
}

.team-date {
	color: #3c3c3c;
	font-size: 1.075rem;
}

</style>



<Navigate styles="team card" to="/my/team/{team.id}">

	<div class="card-content">

		<div class="columns is-mobile is-vcentered is-2 is-variable">

			<!-- <div class="column is-narrow">
				<figure class="image is-48x48 team-image">
					<img src="{team.image}">
				</figure>
			</div>
 -->
			<div class="column">

				<p class="team-name">
					{team_instance_name}
				</p>

				{#if team.team.division}
				<p class="team-level">
					<span>{team.team.division.name}</span>
				</p>
				{/if}

			</div>

			<div class="column is-narrow">

				<p class="team-date">

					{#if team.year_start === team.year_end}
						{team.year_start}
					{:else}
						{team.year_start} - {team.year_end}
					{/if}

				</p>

			</div>

		</div>

	</div>

</Navigate>



